<template>
  <m-card
    padding-xs
    flat
    bordered
    clickable
    class="sign-in-account-row"
    @click="emit('select')"
  >
    <div class="_inner">
      <m-avatar
        :src="image"
        :text="name"
        :amount-chars="1"
        :size="22"
      />
      <div class="_name">
        {{ name }}
      </div>
      <m-spinner
        v-if="loading"
        size="xs"
        class="_indicator"
      />
      <m-icon
        v-else-if="locked"
        type="lock"
        class="_indicator"
      />
    </div>
  </m-card>
</template>

<script setup>
defineProps({
  name: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    default: '',
  },
  locked: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['select']);
</script>

<style scoped lang="scss" type="text/scss">
  .sign-in-account-row {
    cursor: pointer;

    &:hover {
      background-color: $hover-color;
    }

    ._inner {
      display: flex;
      align-items: center;
      gap: 1rem;

      ._name {
        flex: 1;
        overflow: hidden;
        font-size: $font-size-5;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      ._indicator {
        margin-right: .6rem;
        flex-shrink: 0;
        color: $font-color-secondary;
      }
    }
  }
</style>
